module.exports = __webpack_public_path__ + "static/media/tank.54bc76e6.jpg";